import { render, staticRenderFns } from "./ChildDevice.vue?vue&type=template&id=2886d214&scoped=true&"
import script from "./ChildDevice.vue?vue&type=script&lang=js&"
export * from "./ChildDevice.vue?vue&type=script&lang=js&"
import style0 from "./ChildDevice.vue?vue&type=style&index=0&id=2886d214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886d214",
  null
  
)

export default component.exports